// Lightweight event emitter so the Apollo error link (which lives outside the
// React tree) can notify navigation components about authentication failures.

const listeners = new Set();

/**
 * Register a callback that fires when an auth failure is detected.
 * Returns an unsubscribe function.
 */
export function onAuthFailure(callback) {
  listeners.add(callback);
  return () => listeners.delete(callback);
}

/**
 * Call this after clearing stored credentials in response to an auth error.
 * All registered listeners will be invoked synchronously.
 */
export function emitAuthFailure() {
  for (const fn of listeners) {
    try {
      fn();
    } catch (e) {
      console.warn("[authEvents] listener error:", e);
    }
  }
}
